export const S3_CONFIG = {
    endpoint: 'http://localhost:4566',
    bucketName: 'digital-innovation-bucket',
    publicUrl: 'https://pub-e6447b943ea24de3bc274cfd3512094e.r2.dev',
};